import { IColumn } from '../../components';

export const InitiativeColumns: IColumn[] = [
  {
    id: 'initiativeType',
    name: 'Type',
  },
  {
    id: 'title',
    name: 'Initiative',
    width: '20%',
  },
  {
    id: 'priority',
    name: 'Priority',
    width: '20%',
  },
  {
    id: 'initiativeDueDate',
    name: 'Due Date',
    width: '20%',
  },
  {
    id: 'initiativeNote',
    name: 'Notes',
    width: '20%',
  },
] as const;

export const KpiColumns: IColumn[] = [
  {
    id: 'kpi',
    name: '',
    width: '41%',
  },
  {
    id: 'globalBenchmarkKpi',
    name: 'Global Benchmark',
    width: '17%',
  },
  {
    id: 'avedaSalonData',
    name: 'Salon Data',
    width: '17%',
  },
  {
    id: 'status',
    name: 'Status',
    width: '25%',
  },
] as const;

export enum PlanTabsTitle {
  guestPlan = 'Guest Plan',
  teamPlan = 'Team Plan',
  higherTicketsPlan = 'Higher Tickets Plan',
}

export enum ActionPlanGroupsTitle {
  actualGuestCount = 'Actual Guest Count',
  plannedGuestCount = 'Guest Count Goal',
  actualSpCount = 'Actual Service Provider Count',
  plannedSpCount = 'Service Provider Count Goal',
  retailTransactions = 'Actual Retail Transactions',
  serviceTransactions = 'Actual Service Transactions',
  plannedHigherTicketsCount = 'Retail Transactions Goal',
  plannedRetailTicketsCount = 'Service Transactions Goal',
}

export enum ActionPlanGroupsTitleDescription {
  actualGuestCount = 'Total # of Guests in the past quarter',
  plannedGuestCount = 'Goal for Total # of Guests in the next quarter',
  actualSpCount = 'Total # of Service Provider in the past quarter',
  plannedSpCount = 'Goal for Total # of Service Provider in the next quarter',
  retailTransactions = 'Total # of Retail Transactions in the past quarter',
  serviceTransactions = 'Total # of Service Transactions in the past quarter',
  plannedHigherTicketsCount = 'Goal for Total # of Retail Transactions in the next quarter',
  plannedRetailTicketsCount = 'Goal for Total # of Service Transactions in the next quarter',
}

export const blocksOrder: { [key: string]: number } = {
  retailTransactions: 0,
  serviceTransactions: 1,
  actualGuestCount: 1,
  actualSpCount: 1,
  plannedGuestCount: 2,
  plannedSpCount: 2,
  plannedHigherTicketsCount: 2,
  plannedRetailTicketsCount: 2.5,
  kpi: 3,
};
